import React from "react";
import { Stack } from "@mui/material";

import { HubTableTemplate } from "../../components";
import WorkOrderTestStatusChip from "./WorkOrderTestStatusChip";
import WorkOrderTestingContextMenu from "./WorkOrderTestingContextMenu";
import WorkOrderTestName from "./WorkOrderTestName";
import { useGetWorkOrderTests } from "../../hooks";
import Empty from "../../pages/LaborPage/Empty";

const items = [
  {
    id: "name",
    label: "Test",
  },
  {
    id: "createdAt",
    label: "Created At",
  },
  {
    id: "status",
    label: "Status",
  },
];

const keys = [
  {
    value: "name",
    CustomComponent: WorkOrderTestName,
  },
  {
    value: "createdAt",
    isDate: true,
  },
  {
    value: "status",
    CustomComponent: WorkOrderTestStatusChip,
  },
];

export const WorkOrderTestTable = ({ workOrderId }) => {
  const { data: tests, isLoading } = useGetWorkOrderTests(workOrderId);
  const headerProps = { items, includeEnd: true };
  const bodyProps = {
    items: tests,
    keys,
    ContextMenu: WorkOrderTestingContextMenu,
  };
  const props = { headerProps, bodyProps, isLoading };

  return tests?.length ? (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="WorkOrderTestTable" {...props} />
    </Stack>
  ) : (
    <Stack width="100%" height="100%">
      <Empty
        label="No Work Order Tests"
        subtitle="No tests requested for this Work Order"
      />
    </Stack>
  );
};

export default WorkOrderTestTable;
